import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, NgModule, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';
import { InformationPanelComponent } from '@app/components/information-panel/information-panel.component';
import { format } from 'date-fns';
import { CacheService } from '@app/services/cache.service';
import { User } from '@app/models/user';

@Component({
  selector: 'app-error-templates',
  templateUrl: './error-templates.component.html',
  styleUrls: ['./error-templates.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ErrorTemplatesComponent implements OnInit {

  @Input() error: any;
  @Input() componentName: string;
  @Input() errorInfo: HttpErrorResponse;
  @ViewChild('errorInfoTable', { static: true }) errorInfoTable: TemplateRef<any>;
  dialogReference: MatDialogRef<InformationPanelComponent>;
  phone = this.featureSettingsStoreService.state.supportContactPhone;
  email = this.featureSettingsStoreService.state.supportContactEmail;
  userUpn: string;
  currentDate: any;
  user: User;

  constructor(private dialog: MatDialog,
              private featureSettingsStoreService: FeatureSettingsStoreService,
              private cache: CacheService) { }

  ngOnInit() {

    this.user = this.cache.get('UserService-myDetails');
    this.currentDate = format(new Date(), 'yyyy-MM-dd H:mm:ss');

  }

  openErrorInfoTableDialog() {
    this.dialogReference = this.dialog.open(InformationPanelComponent, {
       minWidth: '50vw',
       maxHeight: '90vh',
       minHeight: '90vh',
       maxWidth: '90vw',
       autoFocus: true,
       hasBackdrop: true,
       closeOnNavigation: true,
       panelClass: 'workplace-error-dialog-container',
       data: { content: this.errorInfoTable }
     });
   }

}

@NgModule({
  declarations: [ErrorTemplatesComponent],
  imports: [CommonModule],
  exports: [ErrorTemplatesComponent]
})
export class ErrorTemplatesModule { }
